import React, { useEffect } from 'react'
import { removeStore } from '../../app/store';

export default function Logout() {
  useEffect(() => {
    // Clear all stored data
    removeStore();
    // Redirect to home page - use fallback if env var not set
    const homeUrl = process.env.REACT_APP_MAIN_URL || '/';
    window.location.href = homeUrl;
  }, [])

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px'
    }}>
      Logging out...
    </div>
  )
}
